import React from "react";
import { _t } from "app/i18n/i18n";
import SubscriptionsForecastChart from "components/Subscriptions/SubscriptionsForecastChart/SubscriptionsForecastChart";
import SubscriptionsTopReports from "components/Subscriptions/SubscriptionsTopReports/SubscriptionsTopReports";
import styles from "./SubscriptionsForecast.module.scss";

function SubscriptionsForecast({
  selectedLanguages,
  selectedSubscriptionTags,
  isSubscriptionFromPillsBar,
  selectedPub,
}) {
  return (
    <>
      <SubscriptionsForecastChart
        selectedSubscriptionTags={selectedSubscriptionTags}
        selectedLanguages={selectedLanguages}
        isSubscriptionFromPillsBar={isSubscriptionFromPillsBar}
        selectedPub={selectedPub}
      />

      <div className={styles.card}>
        <h6 className={styles.cardTitle}>{_t("recent-publications")}</h6>
        <SubscriptionsTopReports
          selectedSubscriptionTags={selectedSubscriptionTags}
          selectedLanguages={selectedLanguages}
          isSubscriptionFromPillsBar={isSubscriptionFromPillsBar}
          selectedPub={selectedPub}
        />
      </div>
    </>
  );
}

export default SubscriptionsForecast;
